var multipleModelsV2 = {
  setupCarousel: function setupCarousel() {
    var moreThanOneImage = $(".multipleModelsV2Component-carouselItem").length > 4;
    if (breakpoint.value === 'md' || breakpoint.value === 'lg') {
      //Only init carousel if more than 3 slides
      if (moreThanOneImage) {
        $('.multipleModelsV2Component-carousel').flickity({
          arrowShape: 'M70.5 99.3L21.2 50 70.5.7 76 6.2 32.2 50 76 93.8z',
          lazyLoad: true,
          prevNextButtons: moreThanOneImage,
          pageDots: false,
          draggable: false,
          cellAlign: 'left',
          contain: true
        });
      }
    }
  }
};
$(function () {
  multipleModelsV2.setupCarousel();
});